import { logger } from '@libs/core/utils';
import type { ProductHit } from '@libs/algolia';
import apiProxyClient from '@libs/api-proxy-client';

type FetchFBTProps = {
    productId: string;
    customerId: string;
    storeId: string | undefined;
};

export const fetchFBT = async ({
    productId,
    customerId,
    storeId,
}: FetchFBTProps): Promise<ProductHit[]> => {
    if (!storeId) {
        return [];
    }

    try {
        const fetchedProducts =
            await apiProxyClient.recommendations.getProductRecommendations({
                productId,
                storeId,
                customerId,
            });

        return fetchedProducts.filter(
            (product, index, self) =>
                index ===
                self.findIndex(productSelf => productSelf.id === product.id)
        );
    } catch (error) {
        logger.error('Error fetching product recommendations: %o', error);
        throw error;
    }
};
